export enum MessageType {
    Success,
    Error,
    Information
}